import { render, staticRenderFns } from "./CrearSubmenu.vue?vue&type=template&id=d0b1c610"
import script from "./CrearSubmenu.vue?vue&type=script&lang=js"
export * from "./CrearSubmenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports